// extracted by mini-css-extract-plugin
module.exports = {"component":"QuestionTitle_component__31bW-","title":"QuestionTitle_title__TA6zC"};